import React, { Fragment, useState, useEffect, useMemo } from "react";
import {
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import { Btn, H5, UL, H6, LI } from "../../../AbstractElements";
import { useTranslation } from 'react-i18next';
import {
  EmailAddress,
  LoginWithJWT,
  Password,
  SignIn,
} from "../../../Constant";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { firebase_app, Jwt_token } from "../../../Config/Config";
import man from "../../../assets/images/dashboard/1.png";
import { handleResponse } from "../../../Services/Fack.Backend";
import FormHeader from "./FormHeader";
import FormPassword from "./FormPassword";
import SignInWith from "./SignInWith";
import { Phone, Lock, Key } from "react-feather";
import axios from "axios";
import Language from "../../../Layout/Header/Langauge";

const LoginTab = ({ selected }) => {
  const [phone_number, setPhoneNumber] = useState("");
  const [step, setStep] = useState(false);
  const [step3, setStep3] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [disabled2, setDisabled2] = useState(false);
  const [step2, setStep2] = useState(false);
  const [otpCode, setOtpCode] = useState();
  const lang = localStorage?.getItem('i18nextLng');
  const [isDisabled, setIsDisabled] = useState(true);
  const [password, setPassword] = useState("");
  const [passwordCon, setPasswordCon] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [togglePassword, setTogglePassword] = useState(false);
  const [togglePassword2, setTogglePassword2] = useState(false);
  const [togglePassword3, setTogglePassword3] = useState(false);
  const history = useNavigate();

  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  //const [name, setName] = useState(localStorage.getItem("Name"));

  useEffect(() => {
    localStorage.setItem("profileURL", value);
    ///localStorage.setItem("Name", name);
  }, [value]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (password?.trim() !== "" && !isDisabled) {
    if (password !== passwordCon) {
      toast.error("Password and confirm password do not match");
      return;
    }
    try {
      let link;
        link = "https://api-portal.nada.org.np/api/users/forgot";
      const response2 = await axios.post(
        link,
        {
          phone_number: phone_number,
          new_password: password,
          otp_code: otpCode,
        }
      );
      if (response2?.data?.success) {
        setPassword("");
        setPasswordCon("");
        setOtpCode("");
        setPhoneNumber("");
        setStep(false);
        setStep2(false);
        toast.success(response2?.data?.message);
        window.location.href = `${process.env.PUBLIC_URL}/login`;
      } else {
        toast.error(response2?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      if (error.response) {
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
    }
  } else {
    toast.error("Please enter valid password");
  }
  };


  const validatePassword = (password) => {
    const lengthValid = password.length >= 8;
    const upperCaseValid = /[A-Z]/.test(password);
    const lowerCaseValid = /[a-z]/.test(password);
    const numberValid = /[0-9]/.test(password);
    const specialCharValid = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return {
        lengthValid,
        upperCaseValid,
        lowerCaseValid,
        numberValid,
        specialCharValid,
    };
  };

  const validation = useMemo(() => validatePassword(password), [password]);

  useEffect(() => {
    if (password !== '') {
            if(validation && validation.lengthValid && validation.upperCaseValid && validation.lowerCaseValid && validation.numberValid && validation.specialCharValid) {
                setIsDisabled(false);
            } else {
                setIsDisabled(true);
            }
    } else {
        setIsDisabled(true);
    }
  },[password, validation]);

  const handleLogin2 = async (e) => {
    e.preventDefault();
    if( phone_number !== "" || phone_number?.length > 10) {
    try {
      const response2 = await axios.post(
        "https://api-portal.nada.org.np/api/users/verify-status-fp",
        {
          phone_number: phone_number
        }
      );
      if (response2?.data?.success) {
          setStep(true);
          setDisabled(true);
      } else {
        toast.error(response2?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      if (error.response) {
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
    }
    } else {
      toast.error("Please enter valid phone number");
    }
  };

  const handleOtp = async (e) => {
    //setStep2(true);
    e.preventDefault();
    if (otpCode !== "" && otpCode?.length === 4) {
    try {
      const response2 = await axios.post(
        "https://api-portal.nada.org.np/api/users/verify-otp",
        {
          phone_number: phone_number,
          otp_code: otpCode,
        }
      );
      if (response2?.data?.success) {
        if (response2?.data?.success) {
          setStep2(true);
          setDisabled2(true);
        } else {
          toast.error(response2?.data?.message);
        }
      } else {
        toast.error(response2?.data?.message, 'hey');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      if (error.response) {
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
    }
    } else {
      toast.error("Please enter valid OTP");
    }
  };


  return (
    <Fragment>
      <Form className="theme-form login-form">
        <FormHeader selected={selected} t={t} />
        <FormGroup>
          <Label>{t("Phone Number")}</Label>
          <InputGroup>
            <InputGroupText>
              <Phone />
            </InputGroupText>
            <Input
              className="form-control"
              type="number"
              required=""
              disabled={disabled}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter the phone number"
              value={phone_number}
            />
          </InputGroup>
        </FormGroup>
        {step &&
        <FormGroup>
            <Label>{t("OTP Code")}</Label>
            <InputGroup>
              <span className="input-group-text">
                <Key />
              </span>
              <Input
                className="form-control"
                type={togglePassword2 ? "text" : "password"}
                //name="login[password]"
                required=""
                disabled={disabled2}
                maxLength={4}
                onChange={(e) => setOtpCode(e.target.value)}
                value={otpCode}
                placeholder={t("Enter 4-digit code")}
              />
              <div
              className="show-hide"
              onClick={() => setTogglePassword2(!togglePassword)}
            >
              <span className={togglePassword2 ? "" : "show"}></span>
            </div>
            </InputGroup>
          </FormGroup>
}
        {step2 &&
        <>
        <FormGroup>
          <Label>{t("New Password")}</Label>
          <InputGroup>
            <InputGroupText>
              <Lock />
            </InputGroupText>
            <Input
              className="form-control"
              type={togglePassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required=""
              placeholder="********"
            />
            <div
              className="show-hide"
              onClick={() => setTogglePassword(!togglePassword)}
            >
              <span className={togglePassword ? "" : "show"}></span>
            </div>
          </InputGroup>
        </FormGroup>
        <FormGroup>
        <Label>{t("Confirm New Password")}</Label>
        <InputGroup>
          <InputGroupText>
            <Lock />
          </InputGroupText>
          <Input
            className="form-control"
            type={togglePassword3 ? "text" : "password"}
            onChange={(e) => setPasswordCon(e.target.value)}
            value={passwordCon}
            required=""
            placeholder="********"
          />
          <div
            className="show-hide"
            onClick={() => setTogglePassword3(!togglePassword3)}
          >
            <span className={togglePassword3 ? "" : "show"}></span>
          </div>
        </InputGroup>
      </FormGroup>
        </>
}
       {/*<FormPassword />*/}
       <FormGroup className="d-flex justify-content-between align-items-center">
  {/*<Link
    to={`${process.env.PUBLIC_URL}/pages/authentication/forget-pwd`}
    className="text-decoration-none"
  >
    Forgot Password?
  </Link>*/}
  <div style={{ width: '40%' }}>
    <Btn
      attrBtn={{
        color: 'primary',
        className: 'w-100',
        disabled: loading,
        onClick: (e) =>
          step2
            ? handleLogin(e)
            : step
            ? handleOtp(e)
            : handleLogin2(e),
      }}
    >
      {loading ? 'LOADING...' : t('Continue')}
    </Btn>
  </div>
</FormGroup>
        <SignInWith t={t} />
        {step2 && (
                  <FormGroup>
                      <Label>Your password must have at least:</Label>
                        <LI>8 to 20 characters</LI>
                     <LI>At least 1 uppercase letter and 1 number</LI>
                       <LI>1 special character (e.g. # ? ! $ &amp; @)</LI>
                    </FormGroup>
       )}
        <div style={{ position: 'absolute', top: 1, right: -60, backgroundColor: '#fff', width: 50, height: 40, alignItems: 'center', display: 'flex', justifyContent:'center', borderRadius: '8px' }}>
        <UL attrUL={{ className: `simple-list flex-row nav-menus` }}>
        <LI attrLI={{ className: 'onhover-dropdown' }}><H6 attrH6={{ className: 'txt-dark mb-0 mt-1' }}>{lang === 'es'? 'NP' : 'EN'}</H6>
            <Language />
          </LI>
          </UL>
        </div>
      </Form>
    </Fragment>
  );
};

export default LoginTab;
